import { useEffect, useState } from "react";
import { useMap, ImageOverlay } from "react-leaflet";

const MAX_AZURE_ZOOM = 19;
const AZURE_STATIC_SIZE = 2048;

const AzureStaticOverlay = ({ azureApiKey }) => {
  const map = useMap();
  const [staticImageUrl, setStaticImageUrl] = useState(null);
  const [bounds, setBounds] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const updateStaticImage = () => {
      const zoom = map.getZoom();

      if (zoom > MAX_AZURE_ZOOM) {
        
        setIsLoading(true);

        const center = map.getCenter();
        const url = `https://atlas.microsoft.com/map/static/png?api-version=2.1&layer=hybrid&style=main&zoom=${MAX_AZURE_ZOOM}&center=${center.lng},${center.lat}&width=${AZURE_STATIC_SIZE}&height=${AZURE_STATIC_SIZE}&subscription-key=${azureApiKey}`;

        const img = new Image();
        img.onload = () => {
          setStaticImageUrl(url);

          // bounds = вся видима частина карти
          const pixelBounds = map.getPixelBounds();
          const southWest = map.unproject(pixelBounds.getBottomLeft());
          const northEast = map.unproject(pixelBounds.getTopRight());
          setBounds([southWest, northEast]);

          setIsLoading(false);
        };
        img.onerror = () => {
          setIsLoading(false);
          setStaticImageUrl(null);
        };
        img.src = url;
      } else {
        setStaticImageUrl(null);
        setBounds(null);
        setIsLoading(false);
      }
    };

    map.on("zoomend", updateStaticImage);
    map.on("moveend", updateStaticImage);

    updateStaticImage();

    return () => {
      map.off("zoomend", updateStaticImage);
      map.off("moveend", updateStaticImage);
    };
  }, [map, azureApiKey]);

  if (!staticImageUrl || !bounds) return null;

  return (
    <>
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          padding: '10px',
          borderRadius: '5px',
          background: 'rgba(255,255,255,0.8)',
          fontWeight: 600
        }}>
          Loading maps...
        </div>
      )}
      <ImageOverlay
        url={staticImageUrl}
        bounds={bounds}
        opacity={1}
        zIndex={100}
      />
    </>
  );
};

export default AzureStaticOverlay;